import { ConfirmationEmailRequest } from "@/models/api/ConfirmationEmailRequest";
import { snackbarMessageKey } from "@/models/symbols/Snackbar";
import bookingService from "@/services/booking.service";
import { storageService } from "@/services/storage.service";
import { useBookingStore } from "@/store/booking";
import { useCampaignStore } from "@/store/campaign";
import { useEventBus } from "@vueuse/core";
import { useI18n } from "vue-i18n";

const useBooking = () => {
	const snackbarBus = useEventBus(snackbarMessageKey);
	const { t } = useI18n();
	const bookingStore = useBookingStore();
	const campaignStore = useCampaignStore();

	const sendConfirmationMail = (req: ConfirmationEmailRequest) => {
		return new Promise((resolve, reject) => {
			bookingService.sendConfirmationMail(req).then((resp) => {
				snackbarBus.emit({
					type: "success",
					message: t("account.bookings.emailSent"),
					id: Date.now().toString()
				});

				resolve(resp);
			}).catch((err) => {
				reject(err);
			})
		});
	}
	
		const sendAgentMailCopy = (req: ConfirmationEmailRequest) => {
		return new Promise((resolve, reject) => {
			bookingService.sendAgentMailCopy(req).then((resp) => {
				resolve(resp);
			}).catch((err) => {
				reject(err);
			})
		});
	}

	const cancelActiveBooking = (redirectUrl = ''): Promise<string> => {
		return new Promise((resolve, reject) => {
			if (!storageService.getToken()) {
				resolve('');
			} else {
				bookingService.unloadBookings().then((resp) => {
					bookingStore.$reset();
					campaignStore.$reset();
					if (redirectUrl) {
						window.location.replace(redirectUrl);
					}

					resolve(resp.message);
				}).catch((err) => {
					reject(err);
				})
			}
		});
	}

	return { cancelActiveBooking, sendConfirmationMail, sendAgentMailCopy }
}

export default useBooking;